import { is } from 'immutable';
import {  createSelectorCreator, defaultMemoize } from 'reselect';

const createImmutableSelector = createSelectorCreator(
  defaultMemoize,
  is
);
const eventsSelector = (state: any) => state.get('events');
const getEvents = createImmutableSelector([eventsSelector], events => events.get('items'))
const getEventsError = createImmutableSelector([eventsSelector], events => events.get('error'))
const getCurrentEvent = createImmutableSelector([eventsSelector], events => events.get('currentEvent'))
const getEventsAudioIsMuted = createImmutableSelector([eventsSelector], events => events.get('audioIsMuted'))

export {
  eventsSelector,
  getEvents,
  getEventsError,
  getCurrentEvent,
  getEventsAudioIsMuted,
};
